<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{year}} © Solenex.
            </div>
        </div>
    </div>
</footer>